export const getConstantValueById = (constant, id) => {
  const filteredConstant = constant.find(item => item.id === id);
  if (!filteredConstant)
    throw new Error(`Unable to get constant value for id:${id}`);
  return filteredConstant.value;
};